import { getRegion } from '@/utilities/getters/cookieGetters';
import {
  getBaseURL,
  getBrand,
  getPlatform,
  getProduct,
} from '@/utilities/getters/gameContextGetters';
import {
  getTrendingGamesChannel,
  getUserChannel,
  getUserOS,
} from '@/utilities/helpers/platform';
import { getGlsPlatformType } from '@/utilities/helpers/gls-platform';
import * as wrapperHelpers from '@/utilities/helpers/wrapperHelpers';

const getUserAgent = () =>
  typeof navigator === 'undefined' ? '' : (navigator.userAgent ?? '');

const safeCall = <T>(fn: () => T, fallback: T): T => {
  try {
    const value = fn();
    return value ?? fallback;
  } catch {
    return fallback;
  }
};

const getWrapperType = () => {
  const fn =
    wrapperHelpers.checkWrapperType ??
    wrapperHelpers.checkTypeOfWrapper ??
    (() => ({ isAndroid: false, isXsell: false, isMobile: false }));
  return fn();
};

export const buildRuntimeState = () => ({
  userAgent: getUserAgent(),
  deviceType: safeCall(() => getUserChannel(), ''),
  wrapperType: safeCall(() => getWrapperType(), {
    isAndroid: false,
    isXsell: false,
    isMobile: false,
  }),
  userOS: safeCall(() => getUserOS(), ''),
  baseURL: safeCall(() => getBaseURL(), ''),
  region: safeCall(() => getRegion(), ''),
  brand: safeCall(() => getBrand(), ''),
  platform: safeCall(() => getPlatform(), 'desktop'),
  glsPlatform: safeCall(() => getGlsPlatformType(), 'DESKTOP'),
  product: safeCall(() => getProduct(), ''),
  channel: safeCall(() => getTrendingGamesChannel(), ''),
});

export type RuntimeState = ReturnType<typeof buildRuntimeState>;

export type RuntimeSlice = {
  runtime: RuntimeState;
};
